/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './reassignQueue.defs.js'
export { main as default } from './reassignQueue.defs.js'
